import * as React from 'react';
import styled from 'styled-components';

interface IProps {
  /** @ignore */
  className?: string;
}

const PaneSeparatorBase = (props: IProps) => {
  return (<div className={props.className}></div>);
}

const PaneSeparator = styled(PaneSeparatorBase)`
  position: relative;
  height: 18px;
  &:after {
    content: '';
    z-index: 1;
    position: absolute;
    top: 5px;
    height: 0;
    left: 50%;
    margin-left: -20px;
    width: 40px;
    border-bottom: solid 1px ${p => p.theme.colors.neutral[50]};
  }
`

export { PaneSeparator }
